import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-politicaprivacidad',
  templateUrl: './politicaprivacidad.component.html',
  styleUrls: ['./politicaprivacidad.component.css']
})
export class PoliticaprivacidadComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
